<template>
  <div class="col-xl-3 col-lg-4 theiaStickySidebar">
    <div class="card dq-gs-nav-card border-0">
      <div class="card-body">
        <p class="text-muted small fw-semibold text-uppercase mb-2 px-1" style="letter-spacing: 0.06em">
          General settings
        </p>
        <nav class="d-flex flex-column gap-1" aria-label="General settings">
          <template v-for="item in navItems" :key="item.to">
            <router-link
              v-if="!item.comingSoon"
              :to="item.to"
              class="dq-gs-nav-link"
              active-class="active"
              exact-active-class="active"
            >
              <span class="dq-gs-nav-icon">
                <i :class="item.icon"></i>
              </span>
              <span class="dq-gs-nav-text">
                <span class="dq-gs-nav-title">{{ item.label }}</span>
                <span class="dq-gs-nav-desc">{{ item.description }}</span>
              </span>
            </router-link>

            <span
              v-else
              class="dq-gs-nav-link dq-gs-nav-link--disabled"
              aria-disabled="true"
              :title="`${item.label} — coming soon`"
            >
              <span class="dq-gs-nav-icon">
                <i :class="item.icon"></i>
              </span>
              <span class="dq-gs-nav-text">
                <span class="dq-gs-nav-title-row">
                  <span class="dq-gs-nav-title">{{ item.label }}</span>
                  <span class="badge rounded-pill dq-gs-badge-soon">Coming soon</span>
                </span>
                <span class="dq-gs-nav-desc">{{ item.description }}</span>
              </span>
            </span>
          </template>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const navItems = computed(() => [
  {
    to: "/general-settings/profile-settings",
    label: "Company details",
    description: "Logo, PIN, bank & signatory",
    icon: "ti ti-building",
  },
  {
    to: "/general-settings/security-settings",
    label: "Security",
    description: "Profile, password & devices",
    icon: "ti ti-shield-lock",
  },
  {
    to: "/general-settings/notification-settings",
    label: "Notifications",
    description: "Email, SMS, and push preferences",
    icon: "ti ti-bell",
    comingSoon: true,
  },
  {
    to: "/general-settings/connected-apps",
    label: "Connected apps",
    description: "Third-party integrations",
    icon: "ti ti-plug-connected",
    comingSoon: true,
  },
]);
</script>
